/**
 * 配列から一様ランダムに 1 要素を選ぶ。
 *
 * rjf01（ボスのテレポート候補・火の粉の色）、rjf02（ピンの色）、
 * rjf05（マトの一辺）、rjf06（ネッシーの候補・火の球の一辺）に重複していた
 * `items[Math.floor(Math.random() * items.length)]` を 1 箇所へ集約する。
 * 式は元コードと同一（Lua の rand:NextInteger(1, n) による一様選択の移植）。
 *
 * 空配列は渡さないこと（候補は常に 1 件以上、という呼び出し側の不変条件を
 * 前提に undefined を返さない型にしている。元のインライン式と同じ前提）。
 */
export const pickRandom = <T>(items: ReadonlyArray<T>): T =>
  items[Math.floor(Math.random() * items.length)]
